import { signal } from 'services/SignalsService'

export default class IntroScreenEntity extends PIXI.Container {
  constructor() {
    super()
    this.loaderContainer
    signal.once('ACTION:LOAD', this.setLoader.bind(this))
  }

  setLoader() {
    const reaLWidth = this.loaderContainer.width
    this.loaderContainer.width = 0
    const loader = PIXI.Loader.shared

    loader.onProgress.add(() => {
      this.loaderContainer.width = reaLWidth * loader.progress / 100
    })
  }

  register = (type, object) => {
    if (type === 'Loader') {
      this.loaderContainer = object
    }
  }
}
